export default __webpack_public_path__ + "static/media/icons8-react.cad3ac6b.svg";